module.exports = __webpack_public_path__ + "img/W-S16.26b641ce.jpg";